export default [
	{
		href: '/goods/list',
		name: 'List',
		permission: null
	},
	{
		href: '/goods/categories',
		name: 'Categories',
		permission: null
	}
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/goods/tabs.js